import {
  JSON_FILE,
  JSON_FILE_FAILURE,
  JSON_FILE_SUCCESS,
} from "../types";

export const getJsonFile = (payload) => ({
  type: JSON_FILE,
  payload
});

export const getJsonFileSuccess = (payload) => ({
  type: JSON_FILE_SUCCESS,
  payload,
});

export const getJsonFileFailure = (payload) => ({
  type: JSON_FILE_FAILURE,
  payload,
});
